<script lang="ts">
    import Zframe from '../../_common/z/zframe.svelte'
    import Content from '../../_common/content.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zbutton from '../../_common/z/zbutton.svelte'

    async function disconnectAll() {
        await window.api.users.auth.invalidateTokens()
        location.href = '/login'
    }

    async function goHome() {
        location.href = '/'
    }
</script>

<Content>
    <Zact><div class="spacer" /></Zact>
    <Zframe title="Alterar senha" class="mt-3">
        <div class="box-change-pass">
            <div class="alert alert-success text-center">Senha alterada com sucesso.</div>
            <div class="box-change-pass_acts">
                <Zbutton class="me-2 mb-2" on:click={disconnectAll} label="Desconectar de todos os dispositivos"></Zbutton>
                <Zbutton class="mb-2" on:click={goHome} label="Ir para o início"></Zbutton>
            </div>
        </div>
    </Zframe>
</Content>

<style>
    .box-change-pass {
        max-width: 412px;
        margin: 0 auto;
        padding: 8px;
        border-radius: 8px;
        margin-top: 16px;
    }

    .box-change-pass .box-change-pass_acts {
        display: flex;
        flex-direction: column;
    }

    .box-change-pass :global(.box-change-pass_acts > *) {
        width: 100%;
    }
</style>
